import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false,
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__fintegrate-features',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__fintegrate-features .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__fintegrate-integrate',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__fintegrate-integrate .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__fintegrate-conversion',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__fintegrate-conversion .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__fintegrate-antifrod',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__fintegrate-antifrod .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__fintegrate-analytic',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__fintegrate-analytic .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__fintegrate-control',
        triggerHook: 0.95,
        reverse: false,
    })
    .setClassToggle('.l-page__fintegrate-control .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__poscredit-solution-keys',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__poscredit-solution-keys .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__connect',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__connect .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false,
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);


});



// WEBPACK FOOTER //
// ./app/scripts/pages/solutions/fintegrate.js